import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { useAuth, AuthProvider } from './auth-context';
import { ToastProvider } from './components/shared/Toast';
import { ProtectedRoute } from './components/shared/ProtectedRoute';
import { ProfileSelector } from './components/child/ProfileSelector';
import { PinEntry } from './components/child/PinEntry';
import { ChildDashboard } from './components/child/Dashboard';
import { SurahPicker } from './components/child/SurahPicker';
import { Recorder } from './components/child/Recorder';
import { Review } from './components/child/Review';
import { SurahComplete } from './components/child/SurahComplete';
import { MessagesArchive } from './components/child/MessagesArchive';
import { ChildProfile } from './components/child/Profile';
import { ParentDashboard } from './components/parent/Dashboard';
import { AudioFeed } from './components/parent/AudioFeed';
import { ChildDetailScreen } from './components/parent/ChildDetail';
import { WeekView } from './components/parent/WeekView';
import { Settings } from './components/parent/Settings';
import { useEffect } from 'react';
import { AppShell } from './components/shared/AppShell';

function RootRedirect() {
  const navigate = useNavigate();
  const { state } = useAuth();
  useEffect(() => {
    if (state.status === 'child') navigate('/child', { replace: true });
    else if (state.status === 'parent') navigate('/parent', { replace: true });
  }, [state.status, navigate]);
  if (state.status === 'loading') {
    return (
      <AppShell>
        <main className="flex min-h-dvh items-center justify-center text-ink-muted text-[13px]" />
      </AppShell>
    );
  }
  if (state.status === 'anonymous') return <ProfileSelector />;
  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login/child/:id" element={<PinEntry mode="child" />} />
          <Route path="/login/parent" element={<PinEntry mode="parent" />} />

          <Route
            path="/child"
            element={
              <ProtectedRoute role="child">
                <ChildDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/child/surah-picker"
            element={
              <ProtectedRoute role="child">
                <SurahPicker />
              </ProtectedRoute>
            }
          />
          <Route
            path="/child/record"
            element={
              <ProtectedRoute role="child">
                <Recorder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/child/review"
            element={
              <ProtectedRoute role="child">
                <Review />
              </ProtectedRoute>
            }
          />
          <Route
            path="/child/surah-complete"
            element={
              <ProtectedRoute role="child">
                <SurahComplete />
              </ProtectedRoute>
            }
          />
          <Route
            path="/child/messages"
            element={
              <ProtectedRoute role="child">
                <MessagesArchive />
              </ProtectedRoute>
            }
          />
          <Route
            path="/child/profile"
            element={
              <ProtectedRoute role="child">
                <ChildProfile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/parent"
            element={
              <ProtectedRoute role="parent">
                <ParentDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/parent/feed"
            element={
              <ProtectedRoute role="parent">
                <AudioFeed />
              </ProtectedRoute>
            }
          />
          <Route
            path="/parent/children/:id"
            element={
              <ProtectedRoute role="parent">
                <ChildDetailScreen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/parent/week"
            element={
              <ProtectedRoute role="parent">
                <WeekView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/parent/settings"
            element={
              <ProtectedRoute role="parent">
                <Settings />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ToastProvider>
    </AuthProvider>
  );
}
